import { useMutation, useQueryClient } from "@tanstack/react-query";
import galleriesAPI from "../../api/galleries/api";

export function useDeleteGallery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: galleriesAPI.deleteGallery,
    onSuccess: (data, variables) => {
      // Invalidate and refetch galleries list
      queryClient.invalidateQueries({ queryKey: ["galleries"] });

      // Remove specific gallery from cache
      queryClient.removeQueries({ queryKey: ["galleries", variables] });
    },
    onError: (error) => {
      console.error("Delete gallery failed:", error);
    },
  });
}
